import { useSelector } from "react-redux";
import "styles/Profile.css";

const getInitials = (firstName, lastName) => {
  if (!firstName || !lastName) return "";
  const firstInitial = firstName.charAt(0).toUpperCase();
  const lastInitial = lastName.charAt(0).toUpperCase();
  return firstInitial + lastInitial;
};

const ProfileCard = ({ light }) => {
  const user = useSelector((state) => state.global);
  const initials = getInitials(user.firstName, user.lastName);

  return (
    <div className="d-flex align-items-center">
      <div className="avatar-circle d-flex align-items-center justify-content-center">
        {initials}
      </div>
      <div className={`ms-2 d-flex flex-column ${light && "text-white"}`}>
        <small>
          {user.firstName} {user.lastName}
        </small>
      </div>
    </div>
  );
};

export default ProfileCard;
